import { createMap, forMember, mapFrom, constructUsing, mapWith } from "@automapper/core";
import { P2PSender, AccountVerificationStatus, FeatureAccessStatus } from "../../contract/pam.js";
import { P2PLimitsTypeName, P2PLimitsViewModelTypeName, P2PSenderTypeName, P2PSenderViewModelTypeName, P2PGlobalSettingsModelTypeName, P2PGlobalSettingsViewModelTypeName, P2PGlobalSettingsViewModelKeysTypeName, P2PGlobalSettingsQueryFieldsTypeName } from "./constants.js";
class P2PGlobalSettingsMapping {
  createMapping(mapper) {
    createMap(
      mapper,
      P2PLimitsTypeName,
      P2PLimitsViewModelTypeName,
      forMember(
        (vm) => vm.daily,
        mapFrom((m) => m?.daily)
      ),
      forMember(
        (vm) => vm.weekly,
        mapFrom((m) => m?.weekly)
      ),
      forMember(
        (vm) => vm.monthly,
        mapFrom((m) => m?.monthly)
      )
    );
    createMap(
      mapper,
      P2PSenderTypeName,
      P2PSenderViewModelTypeName,
      constructUsing((m) => {
        const mapper2 = {
          [P2PSender.Agent]: "Agent",
          [P2PSender.AgentPlayer]: "AgentPlayer",
          [P2PSender.NormalPlayer]: "NormalPlayer"
        };
        return m ? mapper2[m] : void 0;
      })
    );
    createMap(
      mapper,
      P2PGlobalSettingsModelTypeName,
      P2PGlobalSettingsViewModelTypeName,
      forMember(
        (vm) => vm.id,
        mapFrom((m) => m?.id)
      ),
      forMember(
        (vm) => vm.is_kyc_approved,
        mapFrom((m) => m?.kyc_status ? m.kyc_status === AccountVerificationStatus.Approved : null)
      ),
      forMember(
        (vm) => vm.country,
        mapFrom((m) => m?.country)
      ),
      forMember(
        (vm) => vm.license_type,
        mapFrom((m) => m?.license_type)
      ),
      forMember(
        (vm) => vm.is_agent,
        mapFrom((m) => m?.is_agent)
      ),
      forMember(
        (vm) => vm.p2p_sender,
        mapWith(P2PSenderViewModelTypeName, P2PSenderTypeName, (m) => m.p2p_sender)
      ),
      forMember(
        (vm) => vm.is_p2p_locked,
        mapFrom((m) => m?.p2p_status ? m.p2p_status === FeatureAccessStatus.Locked : null)
      ),
      forMember(
        (vm) => vm.limits,
        mapWith(P2PLimitsViewModelTypeName, P2PLimitsTypeName, (m) => m?.limits)
      ),
      forMember(
        (vm) => vm.updated_at,
        mapFrom((m) => m?.updated_at)
      ),
      forMember(
        (vm) => vm.updated_by,
        mapFrom((m) => m?.updated_by)
      ),
      forMember(
        (vm) => vm.daily_transfer_count,
        mapFrom((m) => m?.daily_transfer_count)
      ),
      forMember(
        (vm) => vm.credit_limits,
        mapWith(P2PLimitsViewModelTypeName, P2PLimitsTypeName, (m) => m?.credit_limits)
      ),
      forMember(
        (vm) => vm.debit_limits_to_agent,
        mapWith(P2PLimitsViewModelTypeName, P2PLimitsTypeName, (m) => m?.debit_limits_to_agent)
      ),
      forMember(
        (vm) => vm.debit_limits_to_player,
        mapWith(P2PLimitsViewModelTypeName, P2PLimitsTypeName, (m) => m?.debit_limits_to_player)
      )
    );
    createMap(
      mapper,
      P2PGlobalSettingsViewModelKeysTypeName,
      P2PGlobalSettingsQueryFieldsTypeName,
      constructUsing((m) => {
        const mapper2 = {
          country: "country",
          is_agent: "is_agent",
          license_type: "license_type",
          "limits.daily": "limits.daily",
          "limits.weekly": "limits.weekly",
          "limits.monthly": "limits.monthly",
          updated_at: "updated_at.seconds",
          updated_by: "updated_by",
          is_kyc_approved: "kyc_status",
          is_p2p_locked: "p2p_status",
          p2p_sender: "p2p_sender",
          daily_transfer_count: "daily_transfer_count",
          "credit_limits.daily": "credit_limits.daily",
          "debit_limits_to_agent.daily": "debit_limits_to_agent.daily",
          "debit_limits_to_agent.weekly": "debit_limits_to_agent.weekly",
          "debit_limits_to_agent.monthly": "debit_limits_to_agent.monthly",
          "debit_limits_to_player.daily": "debit_limits_to_player.daily",
          "debit_limits_to_player.weekly": "debit_limits_to_player.weekly",
          "debit_limits_to_player.monthly": "debit_limits_to_player.monthly"
        };
        return mapper2[m];
      })
    );
  }
}
export {
  P2PGlobalSettingsMapping
};
//# sourceMappingURL=mapper.js.map
